(()=>{
  const money=(cents)=>{try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(cents/100)}catch(e){return '$'+(cents/100).toFixed(2)}};
  const discountFor=q=>q>=21?0:q>=11?.10:q>=6?.05:0;

  function init(root){
    const panel=root.querySelector('[data-me-commerce-intelligence]');
    const input=root.querySelector('[data-me-pp-quantity-input]');
    if(!panel||!input||panel.dataset.ready)return;
    panel.dataset.ready='true';

    const status=panel.querySelector('[data-me-ci-status]');
    const savings=panel.querySelector('[data-me-ci-savings]');
    const total=panel.querySelector('[data-me-ci-total]');
    const unit=panel.querySelector('[data-me-ci-unit]');
    let lastQuantity=null;

    const readQuantity=()=>{
      const raw=String(input.value??'').trim();
      if(raw==='')return 1;
      const parsed=Number.parseInt(raw,10);
      return Number.isFinite(parsed)&&parsed>0?parsed:1;
    };

    const update=()=>{
      const q=readQuantity();
      const base=Number.parseInt(panel.dataset.basePriceCents||'0',10)||0;
      const d=discountFor(q);
      const per=Math.round(base*(1-d));

      panel.querySelectorAll('[data-me-ci-tier]').forEach(t=>{
        const min=Number.parseInt(t.dataset.meCiTier,10);
        const active=(q>=21&&min===21)||(q>=11&&q<21&&min===11)||(q>=6&&q<11&&min===6)||(q<6&&min===1);
        t.classList.toggle('is-active',active);
        t.setAttribute('aria-current',active?'true':'false');
      });

      status.textContent=q>=21?'Custom bulk pricing — quote required':(d?`${Math.round(d*100)}% quantity savings estimated`:'Regular pricing');

      savings.hidden=true;
      savings.textContent='';
      if(d&&base>0){
        savings.textContent=`Save ${money((base-per)*q)}`;
        savings.hidden=false;
      }

      total.textContent=money(per*q);
      unit.textContent=`${money(per)} per item before customization and shipping`;

      const prop=document.querySelector('[data-me-volume-discount-property]');
      if(prop)prop.value=d?`${Math.round(d*100)}% estimated (${q} items)`:'None';
      lastQuantity=q;

      window.dispatchEvent(new CustomEvent('me:quantity-pricing-updated',{detail:{quantity:q,discount:d}}));
    };

    input.addEventListener('input',update);
    input.addEventListener('change',update);
    input.addEventListener('blur',update);
    root.querySelectorAll('[data-me-pp-quantity-minus],[data-me-pp-quantity-plus]').forEach(b=>b.addEventListener('click',()=>{
      requestAnimationFrame(()=>requestAnimationFrame(update));
    }));

    window.setInterval(()=>{
      const current=readQuantity();
      if(current!==lastQuantity)update();
    },500);

    update();

    document.addEventListener('me:variant-change',e=>{
      const price=e.detail&&e.detail.price;
      if(Number.isFinite(price)){
        panel.dataset.basePriceCents=String(price);
        update();
      }
    });
  }

  const boot=()=>document.querySelectorAll('.me-pp').forEach(init);
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot):boot();
})();
